import React from 'react'
import _ from 'lodash'
import moment from 'moment'
import {
  PixelButton,
  PixelDiv,
  PixelDropDown,
  PixelFactoryContext,
  PixelFlexBox,
  PixelInput,
  PixelText,
} from 'pixel-base'

import { get, getPaymentHeads, post } from 'utils/api-routes.util'

const PayViaStripe = (props) => {
  const { invoiceId, invoiceData, customerData, handleClose } = props
  const { showSuccess, showFailure, showPageLoader, hidePageLoader } =
    React.useContext<IPixelFactory>(PixelFactoryContext)
  const [error, setError] = React.useState({ error: '', field: '' })
  interface PaymentMethod {
    name: string
    value: string
  }
  interface IMethod {
    account_name: string
    card_number: string
    card_type: string
    cvc: string | null
    expiry_date: string
    id: number
    method_type: string
    is_default: boolean
    stripe_payment_method_id: string
  }
  const [paymentMethod, setPaymentMethod] = React.useState<PaymentMethod[]>([])
  const [method, setMethod] = React.useState([])
  const [bankHeads, setBankHeads] = React.useState({})
  const [incomeHeads, setIncomeHeads] = React.useState({})

  const [data, setData] = React.useState({
    date: moment(new Date()).format('YYYY-MM-DD'),
    amount: '',
    payment_method: '',
    comments: '',
    income_head_id: '',
    bank_head_id: '',
  })

  const formatOptions = (data) => {
    const options = {
      ...data,
    }
    Object.keys(options).map((key) => {
      return options[key].map((item) => {
        item.value = Number(item.id)
        item.label = item.account_name

        return item
      })
    })
    return options
  }

  const getPaymentMethods = (customerData: any) => {
    if (customerData.customer_id) {
      get(`/customer/${customerData.customer_id}/payment-method`).subscribe(
        (res: any) => {
          const responseData = res?.response?.data
          setMethod(responseData)
          if (Array.isArray(responseData)) {
            const method_name: PaymentMethod[] = responseData?.map((item) => ({
              name: `${item.account_name} **** **** **** ${item.card_number} (${item.card_type})`,
              value: item.stripe_payment_method_id,
            }))
            setPaymentMethod(method_name)
          } else if (responseData && responseData?.id) {
            const method_name: PaymentMethod[] = [
              {
                name: responseData.data.account_name,
                value: responseData.data.stripe_payment_method_id,
              },
            ]

            setPaymentMethod(method_name)
          }
        },
      )
    }
  }

  const paymentHeads = () => {
    getPaymentHeads().subscribe((res) => {
      const dataIs = res.response?.data
      setBankHeads(_.groupBy(dataIs?.bank_heads, 'classification.title'))
      setIncomeHeads(_.groupBy(dataIs?.income_heads, 'classification.title'))
    })
  }

  React.useEffect(() => {
    setData({
      ...data,
      amount: invoiceData?.invoice_balance_amount,
      date: moment(new Date()).format('YYYY-MM-DD'),
    })
    method.map((item: IMethod) => {
      if (item.is_default) {
        setData({
          ...data,
          payment_method: item.stripe_payment_method_id,
        })
      } else {
        data.payment_method
          ? ' '
          : setData({
              ...data,
              payment_method: paymentMethod[0]?.value,
            })
      }
    })
  }, [invoiceData, paymentMethod])

  React.useEffect(() => {
    getPaymentMethods(customerData)
    paymentHeads()
    customerData
  }, [customerData])

  const handelSubmit = (e) => {
    e.preventDefault()
    showPageLoader()
    post(
      `/invoice/${invoiceId}/pay-with-stripe/${customerData.customer_id}`,
      data,
    ).subscribe((res) => {
      if (res?.response?.data) {
        hidePageLoader()
        showSuccess(`${data?.amount} Successfully Detucted`)
        handleClose(res?.response?.data)
      } else {
        hidePageLoader()
        handleClose()
        setError({
          error: res?.response?.error ?? 'Something went wrong',
          field: ' ',
        })
        showFailure(res?.response?.error ?? 'Something went wrong')
      }
    })
  }

  return (
    <form onSubmit={handelSubmit}>
      <PixelFlexBox gap="10px" flexDirection="column">
        <PixelText textSize={'12px'} customColor={'gray'}>
          {
            'Verify the invoice amount on Admin invoices with those provided by the customer'
          }
        </PixelText>
        <PixelFlexBox>
          <PixelDiv style={{ width: '100%' }}>
            <PixelInput
              as="datePicker"
              isShowLabel={true}
              placeholder="Date"
              value={data.date}
              onChange={(e) =>
                setData({
                  ...data,
                  date: moment(e).format('YYYY-MM-DD'),
                })
              }
              name={'Date'}
            />
          </PixelDiv>
        </PixelFlexBox>
        <PixelFlexBox>
          <PixelInput
            error={
              error.field === 'amount' && error.error !== ''
                ? error.error
                : null
            }
            type="number"
            placeholder="Amount"
            name="Amount"
            value={data.amount}
            onChange={(e) => {
              setData({ ...data, amount: e.target.value })
            }}
          />
        </PixelFlexBox>
        <PixelFlexBox>
          <PixelDropDown
            isgrouped={true}
            placeholder={'Categorize Sales'}
            customLabel={'Categorize Sales'}
            error={
              error.field === 'account_name' && error.error !== ''
                ? error.error
                : null
            }
            required
            groupOptionData={formatOptions(incomeHeads)}
            value={data.income_head_id}
            onChange={(e) => {
              setData({ ...data, income_head_id: e.target.value })
            }}
          />
        </PixelFlexBox>
        <PixelFlexBox>
          <PixelDropDown
            isgrouped={true}
            placeholder={'Receiving Account'}
            customLabel={'Receiving Account'}
            error={
              error.field === 'account_name' && error.error !== ''
                ? error.error
                : null
            }
            required
            groupOptionData={formatOptions(bankHeads)}
            value={data.bank_head_id}
            onChange={(e) => {
              setData({ ...data, bank_head_id: e.target.value })
            }}
          />
        </PixelFlexBox>
        <PixelFlexBox>
          <PixelDropDown
            error={
              error.field === 'payment_method' && error.error !== ''
                ? error.error
                : null
            }
            required
            options={[
              { label: 'Select Payment Method', value: '' },
              ...paymentMethod.map((i) => ({
                label: i.name,
                value: i.value,
              })),
            ]}
            value={data.payment_method}
            onChange={(e) => {
              setData({ ...data, payment_method: e.target.value })
            }}
            placeholder={'Payment Method'}
          />
        </PixelFlexBox>

        <PixelFlexBox>
          <PixelInput
            error={
              error.field === 'note' && error.error !== '' ? error.error : null
            }
            as="textarea"
            placeholder="Note"
            name="Note"
            value={data.comments}
            onChange={(e) => {
              setData({ ...data, comments: e.target.value })
            }}
          />
        </PixelFlexBox>
      </PixelFlexBox>
      <PixelFlexBox gap="10px" justifyContent="flex-end">
        <PixelButton variant="outline" onClick={handleClose}>
          Close
        </PixelButton>
        <PixelButton type="submit" variant="primary">
          Pay
        </PixelButton>
      </PixelFlexBox>
    </form>
  )
}

export default PayViaStripe
